<header class="esn-page-header">
  <div class="esn-page-header__titles">
    <ng-content select="[esn-page-header-breadcrumb]" />
    <h1 class="esn-page-header__title">{{ title() }}</h1>
    @if (subtitle(); as text) {
      <p class="esn-page-header__subtitle">{{ text }}</p>
    }
  </div>
  <div class="esn-page-header__actions">
    <ng-content select="[esn-page-header-actions]" />
  </div>
</header>
